
import { Autocomplete, Banner, InlineStack, Modal, Tag, Text, BlockStack } from "@shopify/polaris";
import { doc, setDoc } from "firebase/firestore";
import { useState } from "react";
import { usePartnerUp } from "../providers/PartnerUpStoreProvider";

const countryCodes = [
  {
    "id": 148838,
    "name": "United States",
    "title": "United States"
  },
  {
    "id": 2202162,
    "name": "France",
    "title": "France"
  },
  {
    "id": 60189,
    "name": "Russia",
    "title": "Russia"
  },
  {
    "id": 1428125,
    "name": "Canada",
    "title": "Canada"
  },
  {
    "id": 1311341,
    "name": "Spain",
    "title": "Spain"
  },
  {
    "id": 62149,
    "name": "United Kingdom",
    "title": "United Kingdom"
  },
  {
    "id": 59470,
    "name": "Brazil",
    "title": "Brazil"
  },
  {
    "id": 114686,
    "name": "Mexico",
    "title": "Mexico"
  },
  {
    "id": 51477,
    "name": "Germany",
    "title": "Germany"
  },
  {
    "id": 365331,
    "name": "Italy",
    "title": "Italy"
  },
  {
    "id": 174737,
    "name": "Turkey",
    "title": "Turkey"
  },
  {
    "id": 304716,
    "name": "India",
    "title": "India"
  },
]

export default function AudienceFiltersModal({ open, onClose }) {

  const { db, store, refetchStore, setToast } = usePartnerUp()
  const [saveLoading, setSaveLoading] = useState(false)

  async function saveStore() {
    try {
      await setDoc(doc(db, 'stores', store.id), {
        audienceFilters: localFilters
      }, { merge: true })
      refetchStore()
      onClose()
      setToast({ content: 'Saved Filters!' })
    } catch (e) {
      setToast({ content: 'Error saving. Please try again.', isError: true })
      console.error(e)
    } finally {
      setSaveLoading(false)
    }
  }
  const [localFilters, setLocalFilters] = useState(store?.audienceFilters || {
    ageGroups: [],
    genders: [],
    countries: []
  })

  return (
    <Modal
      title="Target Customers"
      open={open}
      onClose={onClose}
      primaryAction={{
        content: 'Save',
        onAction: saveStore,
        loading: saveLoading
      }}

      secondaryActions={[
        {
          content: 'Cancel',
          onAction: onClose
        }
      ]}
    >
      <Modal.Section>
        <Banner status="info" title="Set Your Target Customer Demographics">
          <Text>If "Any" is Ok, Remove the Filter</Text>
        </Banner>
      </Modal.Section>
      <Modal.Section>
        <BlockStack gap="5">
          <Autocomplete
            allowMultiple
            onSelect={(value) => {
              const newValue = value.pop()
              setLocalFilters({
                ...localFilters,
                ageGroups: [...localFilters.ageGroups, newValue]
              })
            }}
            label="Ages"
            options={[
              { label: '13-17', value: '13-17' },
              { label: '18-24', value: '18-24' },
              { label: '25-34', value: '25-34' },
              { label: '35-44', value: '35-44' },
              { label: '45-64', value: '45-64' },
              { label: '65+', value: '65-' }
            ].filter(i => !(localFilters.ageGroups?.includes(i.value) === true))}
            selected={localFilters.ageGroups || []}
            textField={
              <Autocomplete.TextField
                placeholder={localFilters?.ageGroups?.length > 5 ? '' : localFilters?.ageGroups?.length > 0 ? "Add Age" : "Any"}
                label="Ages"
                value={''}
                autoComplete="off"
                verticalContent={
                  localFilters?.ageGroups?.length > 0 ? (
                    <InlineStack gap="3" align="start">
                      {
                        localFilters.ageGroups?.map(age => {
                          return (
                            <Tag key={age} onRemove={
                              () => {
                                setLocalFilters({
                                  ...localFilters,
                                  ageGroups: localFilters.ageGroups.filter(i => i !== age)
                                })
                              }
                            }>{age}
                            </Tag>
                          )
                        })
                      }
                    </InlineStack>
                  ) : null
                }
              />
            }
          />
          <Autocomplete
            allowMultiple
            onSelect={(value) => {
              const newValue = value.pop()
              setLocalFilters({
                ...localFilters,
                genders: [...localFilters.genders, newValue]
              })
            }}
            label="Gender"
            options={[
              { label: 'Male', value: 'MALE' },
              { label: 'Female', value: 'FEMALE' },
            ].filter(i => !(localFilters.genders?.includes(i.value) === true))}
            selected={localFilters.genders || []}
            textField={
              <Autocomplete.TextField
                placeholder={localFilters?.genders?.length > 1 ? '' : localFilters?.genders?.length > 0 ? "Add Gender" : "Any"}
                label="Genders"
                value={''}
                autoComplete="off"
                verticalContent={
                  localFilters?.genders?.length > 0 ? (
                    <InlineStack gap="3" align="start">
                      {
                        localFilters?.genders?.map(gender => {
                          return (
                            <Tag onRemove={
                              () => {
                                setLocalFilters({
                                  ...localFilters,
                                  genders: localFilters.genders.filter(i => i !== gender)
                                })
                              }}>
                              {gender}
                            </Tag>
                          )
                        })
                      }
                    </InlineStack>
                  ) : null
                }
              />
            }
          />
          <Autocomplete
            allowMultiple
            onSelect={(value) => {
              const newValue = value.pop()
              setLocalFilters({
                ...localFilters,
                countries: [...localFilters.countries, newValue]
              })
            }}
            label="Countries"
            options={countryCodes?.map(c => {
              return {
                label: c.name,
                value: c.name
              }
            }).filter(i => !(localFilters.countries?.includes(i.value) === true))}
            selected={localFilters.countries || []}
            textField={
              <Autocomplete.TextField
                placeholder={localFilters?.countries?.length > 0 ? "Add Country" : "Any"}
                label="Countries"
                value={''}
                autoComplete="off"
                verticalContent={
                  localFilters?.countries?.length > 0 ? (
                    <InlineStack gap="3" align="start">
                      {
                        localFilters?.countries?.map(country => {
                          return (
                            <Tag onRemove={
                              () => {
                                setLocalFilters({
                                  ...localFilters,
                                  countries: localFilters.countries.filter(i => i !== country)
                                })
                              }}>
                              {country}
                            </Tag>
                          )
                        })
                      }
                    </InlineStack>
                  ) : null
                }
              />
            }
          />
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
}
